export default __webpack_public_path__ + "static/media/linkedin.98d848dd.svg";